<template>
  <div>
    <div class="payment-container">
      <h1>お支払い情報</h1>
      <div class="table-fees">
        <div class="fees-content">
          <div class="fees-usage">
            <div class="fees">
              <p>ご利用料金</p>
              <span v-if="paymentInfo && paymentInfo.totalAmt"
                >{{ paymentInfo.totalAmt | formatInteger }} 円</span
              >
              <span v-if="paymentInfo && paymentInfo.totalAmt === 0">0 円</span>
            </div>
            <div class="vat">
              <p>（うち消費税合計（10%）</p>
              <span v-if="paymentInfo && paymentInfo.totalAmt"
                >{{ Math.round(paymentInfo.totalAmt * (1 / 11)) | formatCurrency }}）</span
              >
              <span v-if="paymentInfo && paymentInfo.totalAmt === 0">0 円）</span>
            </div>
          </div>
          <div class="use-point">
            <h3>＜補助金・ポイント利用＞</h3>
            <div class="item-point">
              <p>企業補助適用額</p>
              <span v-if="paymentInfo && paymentInfo.sbsidTotal"
                >- {{ paymentInfo.sbsidTotal | formatCurrency }}</span
              >
              <span v-if="paymentInfo && paymentInfo.sbsidTotal === 0">0 円</span>
            </div>
            <div class="item-point">
              <p>特別補助金</p>
              <span></span>
            </div>
            <div class="item-point">
              <p>ベネポ利用額</p>
              <span v-if="paymentInfo && paymentInfo.pointUse"
                >- {{ paymentInfo.pointUse | formatInteger }} ポイント（円）</span
              >
              <span v-if="paymentInfo && paymentInfo.pointUse === 0"
                >0 ポイント（円）</span
              >
            </div>
            <a-divider />
            <div class="total">
              <p>お支払い金額</p>
              <span v-if="paymentInfo && paymentInfo.billAmtTotal"
                >{{ paymentInfo.billAmtTotal | formatInteger }} 円</span
              >
              <span v-if="paymentInfo && paymentInfo.billAmtTotal === 0">0 円</span>
            </div>
          </div>
        </div>
      </div>
      <div class="payment-title" v-if="!isPublicStay">
        <ItemTitle v-text="'付与ベネポ'" />
      </div>
      <div ref="appDetail" class="granted-benepo" v-if="!isPublicStay">
        <h1 v-if="paymentInfo && paymentInfo.pointGrntNumAmt">
          {{ paymentInfo.pointGrntNumAmt }} ポイント(円)
        </h1>
        <h1 v-if="paymentInfo && paymentInfo.pointGrntNumAmt === 0">0 ポイント(円)</h1>
        <p>ベネポ付与日 2022年11月20日</p>
        <strong>ポイント付与について</strong><br />
        <span>
          <img src="@/assets/images/recomment-logo1.png" />
          <img src="@/assets/images/recomment-rakuten.png" />
        </span>
        <span>
          をご利用の場合、企業補助金およびベネポご利用分を除いた自己負担額（税込）に対して規定の付与ルールで確定したベネポ数をチェックアウト日から5日後に付与いたします。
        </span>
      </div>
    </div>
    <div class="cancel-container">
      <h1 v-if="cancelPolicies">キャンセル規定</h1>
      <div v-if="cancelPolicies">
        <div class="cancel-content">
          <div v-for="(item, index) in cancelPolicies" :key="index">
            <ItemTitle v-if="item.cancelTitle" v-text="item.cancelTitle" />
            <div class="pb-2" :class="item.cancelTitle ? 'pt-5' : 'pt-0'">
              <div v-if="item.cancelNote1">{{ item.cancelNote1 }}</div>
              <div v-if="item.cancelNote2">{{ item.cancelNote2 }}</div>
            </div>
            <table class="table-common" v-if="checkDataTable(item.cancelPolicyTable)">
              <tr v-if="item.cancelPolicyTable.length">
                <th class="w-1/3">キャンセル日</th>
                <th class="style-t w-2/3">規定率</th>
              </tr>
              <tr v-for="(val, index) in item.cancelPolicyTable" :key="index">
                <td>{{ val.cancelRule }}</td>
                <td class="style-t">{{ val.cancelCond }}</td>
              </tr>
            </table>
          </div>

          <h2 class="font-bold">キャンセルについての補足</h2>
          <li>
            カスタマーセンター及び予約先の営業時間が終了している場合は、翌営業日の扱いとなり規定の料金が発生いたします。（キャンセル規定に時間が表示されている場合は、表示されている時間に準じます。）
          </li>
          <li>
            カフェテリアポイント、その他補助金・割引制度をキャンセル料金に適用することはできません。
          </li>
          <li>
            ご変更の際は、キャンセル手続き後の再手配となりますので、増員・減員・プラン変更が承れない場合がございます。
          </li>
          <li>
            また、ご連絡日に関わらず1名様あたりの宿泊料金が変更となる可能性がございます。
          </li>
          <li>
            団体キャンセル規定が本ページに表示されていない場合でも、10名様以上でのご利用は、団体キャンセル規定が適用となる場合がございます。詳細は施設にお問合せ下さい。
            カスタマーセンター営業期間終了後の当日宿泊のキャンセルならびに問い合わせの連絡につきましては、03-6892-5216までご連絡ください。この場合、キャンセル料金の計算基準は翌日受付扱いとなります。
          </li>
          <li>受付時間/平日21：00～24：00、土日祝18：00～24：00</li>
          <p class="text-primary">
            ※予約番号はお申込と同時に表示されます。<br />
            予約番号の表示がある場合でもまだご予約が確約していない場合があります。<br />
            ご予約可否結果につきましては、ご利用履歴画面の「手配状況」欄もしくは、ご希望回答先に送信いたしておりますメールの内容をご確認ください。
          </p>
        </div>
      </div>
      <div class="button" @click="gotoPath()">
        <button class="ant-button">お申し込み履歴一覧へ戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import ItemTitle from '../ItemTitle'
export default {
  components: {
    ItemTitle
  },
  props: ['paymentInfo', 'cancelPolicy'],
  computed: {
    isPublicStay() {
      const { isPublicStay } = this.$route.query
      return isPublicStay === 'true'
    }
  },
  mounted() {
    this.getCancelPolicies()
  },
  watch: {
    cancelPolicy(val) {
      this.cancelPolicies = val.cancelPolicies
    }
  },
  data() {
    return {
      cancelPolicies: []
    }
  },
  methods: {
    getCancelPolicies() {
      if (this.cancelPolicy) {
        this.cancelPolicies = this.cancelPolicy.cancelPolicies
      }
    },
    gotoPath() {
      const query = this.$route.query
      this.$router.push({ path: '/mypage/orders', query })
    },
    checkDataTable(dataTable) {
      let dataTableStr = ''
      dataTable.forEach((element) => {
        dataTableStr = element.cancelCond + element.cancelRule
      })
      if (dataTableStr) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
